<template>


    <div class="col-span-6 text-sm">



        <div v-if="_rules.length == 0" class="flex items-center justify-start gap-x-2">
            <span>No routing rules created yet. <span
                    class="px-2 py-2 border border-gray-200 rounded-md hover:bg-gray-100 cursor-pointer"
                    @click="addRule()">Add a
                    new rule</span> to get started.</span>

            <UpgradePlan v-if="!plan_rules" />
        </div>

        <div v-else class="flex flex-col justify-start items-start w-full">
            <div v-for="(rule, index) in _rules" class="mt-5 md:mt-0 w-full"
                :key="'rule_' + rule.id + '_' + _new_rule_refresh">
                <jet-section-border v-if="index > 0" />
                <div class="w-full">
                    <rule :rule="rule" :folders="folders" @deleteRule="deleteRule"></rule>
                </div>
            </div>

        </div>

        <div v-if="_rules.length > 0" class="h-5 w-full"></div>

        <div
            class=" mt-5 -mx-4 -mb-5 sm:-mx-6 sm:-mb-6 flex items-center justify-end px-4 py-3 bg-gray-50 border-t border-gray-200 text-right sm:px-6 sm:rounded-bl-md sm:rounded-br-md gap-x-4">

            <jet-button v-if="newRulePending" class="hover:opacity-70 py-2" @click="cancelNewRule()"
                style="background-color: #FFF; color: #111827; border: 1px solid #D1D5DB;">
                Cancel
            </jet-button>
            <jet-button v-if="newRulePending"
                :class="[!newRuleComplete ? 'opacity-50 pointer-events-none' : 'opacity-100', 'hover:opacity-70 py-2']"
                @click="saveNewRule()" style="background-color: #007bff;">
                Create Rule
                <CheckIcon class=" w-4 h-4 ml-2" />
            </jet-button>
            <jet-button v-else class="hover:opacity-70 py-2" @click="addRule()">
                Add New Rule
                <PlusIcon class="w-4 h-4 ml-2" />
            </jet-button>

        </div>




    </div>


</template>

<script>
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Rule from '@/Components/Settings/Rule'
import { PlusIcon, CheckIcon } from "@heroicons/vue/20/solid"
import JetButton from '@/Jetstream/Button'
import UpgradePlan from '@/Components/UI/UpgradePlan.vue'


export default {
    props: {
        rules: {
            type: Array,
            default: []
        },
        tags: {
            type: Array,
            default: []
        },
        folders: {
            type: Array,
            default: []
        },
        plan_rules: {
            type: Boolean,
            default: false
        }
    },
    components: {
        JetSectionBorder,
        Rule, PlusIcon, JetButton,
        UpgradePlan, CheckIcon
    },
    data() {
        return {
            _rules: this.rules,
            newRulePending: false,
            saving: false,
            _new_rule: null,
            _new_rule_refresh: 0,
            _new_rule_model: {
                id: null,
                name: "",
                enabled: true,
                ruleset: {
                    conditions: [
                        {
                            logic: "and",
                            sub_conditions: [
                                {
                                    logic: "and",
                                    subject: "video_source",
                                    operator: "is",
                                    value: "zendesk"
                                },
                                {
                                    logic: "and",
                                    subject: "ticket_tag",
                                    operator: "is",
                                    value: ""
                                }
                            ]
                        }
                    ],
                    action: {
                        subject: "video",
                        action: "move_folder",
                        value: null
                    }
                }
            }
        }
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
    },
    methods: {
        showUpgradeModal: function () {
            this.EventBus.emit('showUpgrade', ['feature', 'rules'])
        },
        cancelNewRule() {
            this.newRulePending = false
            this._new_rule = null
            this._rules.pop()
        },
        addRule() {
            if (!this.plan_rules) {
                this.showUpgradeModal()
                return
            }
            this.newRulePending = true
            this._new_rule = JSON.parse(JSON.stringify(this._new_rule_model))
            this._rules.push(this._new_rule)
        },
        saveNewRule() {
            if (!this.newRuleComplete || this.saving) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/rule';
            axios.post(url, {
                rule: this._new_rule
            })
                .then(response => {
                    // console.log(this._rules)
                    this._rules.pop()
                    this._rules.push(response.data)
                    //console.log(this._rules)
                    this._new_rule = null
                    this.newRulePending = false
                    this._new_rule_refresh++
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("New rule saved", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    let options = {
                        type: "danger",
                        timeout: 10000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("An error occurred: " + e.response.data.message, options)
                    this.saving = false
                });

        },
        deleteRule(rule) {
            let url = this.$page.props.api_url + '/v1/rule/' + rule.id + '/delete';
            this.saving = true
            axios.delete(url)
                .then(response => {
                    const ruleIndex = this._rules.findIndex(r => r.id === rule.id);
                    if (ruleIndex !== -1) {
                        this._rules.splice(ruleIndex, 1);
                    }
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Rule deleted", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    let options = {
                        type: "danger",
                        timeout: 10000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("An error occurred: " + e.response.data.message, options)
                    this.saving = false
                });
        }
    },
    computed: {
        newRuleComplete() {
            return this._new_rule.name !== "" && this._new_rule.ruleset.conditions[0].sub_conditions[1].value != "" && this._new_rule.ruleset.action.subject !== "" && this._new_rule.ruleset.action.value !== null
        }
    }
}
</script>
